import { cn, Message, ThinkingBar } from "@prelude-ai/design-system"
import type { ReactNode } from "react"
import type { ChatMessage as ChatMessageType } from "../types"

export type ChatMessageProps = {
  messageRole: ChatMessageType["role"] | "tool"
  children: ReactNode
  isThinking?: boolean
}

export function ChatMessage({ messageRole: role, children, isThinking }: ChatMessageProps) {
  return (
    <Message className={cn(role === "user" && "flex-row-reverse")}>
      <div className={cn(role === "user" && "max-w-[80%]", "flex min-w-0 flex-col gap-1")}>
        {isThinking && (
          <span className="flex items-center gap-2 text-xs text-muted-foreground">
            Prelude <ThinkingBar />
          </span>
        )}
        {children}
      </div>
    </Message>
  )
}
